var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3535 5.64646L6.35354 0.64646C6.3071 0.599972 6.25196 0.563092 6.19126 0.53793C6.13056 0.512768 6.0655 0.499817 5.99979 0.499817C5.93408 0.499817 5.86902 0.512768 5.80832 0.53793C5.74762 0.563092 5.69248 0.599972 5.64604 0.64646L0.64604 5.64646C0.552219 5.74028 0.499512 5.86753 0.499512 6.00021C0.499512 6.13289 0.552219 6.26014 0.64604 6.35396C0.73986 6.44778 0.867108 6.50049 0.99979 6.50049C1.13247 6.50049 1.25972 6.44778 1.35354 6.35396L5.99979 1.70709L10.646 6.35396C10.6925 6.40042 10.7476 6.43727 10.8083 6.46241C10.869 6.48755 10.9341 6.50049 10.9998 6.50049C11.0655 6.50049 11.1305 6.48755 11.1912 6.46241C11.2519 6.43727 11.3071 6.40042 11.3535 6.35396C11.4 6.30751 11.4368 6.25236 11.462 6.19166C11.4871 6.13096 11.5001 6.06591 11.5001 6.00021C11.5001 5.93451 11.4871 5.86946 11.462 5.80876C11.4368 5.74807 11.4 5.69292 11.3535 5.64646Z",
    fill: "#205F74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.d98717e171d80ce5dd3116b9840be4dc.svg";
export { ForwardRef as ReactComponent };